'use client'

import Image, { ImageProps } from 'next/image'

const imageLoader = ({
  src,
  width,
  quality,
}: {
  src: string
  width: number
  quality?: number
}): string => {
  if (src.startsWith('/')) {
    return `${src}?w=${width}&q=${quality || 75}`
  }

  if (src.includes('?')) {
    return src
  }

  if (src.startsWith('https://')) {
    return `/api/image-proxy?url=${encodeURIComponent(src)}&w=${width}&q=${quality || 75}`
  }

  return src
}

export const RemoteImage: React.FC<ImageProps> = ({
  src,
  alt,
  width,
  height,
  ...rest
}) => {
  if (!src) {
    return null
  }
  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={height}
      loader={imageLoader}
      {...rest}
    />
  )
}
